import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../utils/languageUtils';

interface DateFilterItemProps {
    label: string;
    value?: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
    className?: string;
    spanClassName?: string;
    format?: string;
    disabledDate?: (current: Dayjs | null) => boolean;
    allowClear?: boolean;
    disabled?: boolean;
    minDate?: Dayjs;
    maxDate?: Dayjs;
    placeholder?: string;
    suffixIcon?: React.ReactNode;
}

const DateFilterItem: React.FC<DateFilterItemProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    format = 'YYYY-MM-DD',
    disabledDate,
    allowClear = true,
    disabled,
    minDate,
    maxDate,
    placeholder,
    suffixIcon
}) => {
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={inputContainerClassName}>
                <DatePicker
                    value={value ?? null}
                    onChange={(date) => onChange?.(date)}
                    format={format}
                    disabledDate={disabledDate}
                    allowClear={allowClear}
                    disabled={disabled}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder={placeholder}
                    suffixIcon={suffixIcon}
                    size="middle"
                    style={{ width: '100%' }}
                />
            </div>
        </div>
    );
};

export default DateFilterItem;
